/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { CheckCircle2, Clock, Undo2, Upload, XCircle } from "lucide-react";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Modal from "src/components/Modal";
import { PagBankPaymentStatus } from "src/components/cardsTrade/types";
import { useAuth } from "src/hooks/auth";
import { api } from "src/services/api";
import toLocaleAmount from "src/utils/toLocaleAmount";
import { TransactionPagbankDetail } from "../backoffice/TransactionsPagbankDetails/TransactionPagbankDetail";
import { Container, Content } from "../tax/styles";
import "./style.css";

export type TransactionDataPos = {
	id: string;
	type: string;
	grossAmount: number;
	netAmount: number;
	taxTotal: number;
	isAwaitingTransfer: boolean;
	installments: number;
	machineId: string;
	machineSerial: string;
	transactionId: string;
	created_at: string;
	updated_at: string;
	status: number;
};

// const mockData: TransactionDataPos[] = [
// 	{
// 		id: "1",
// 		type: "1",
// 		grossAmount: 1500,
// 		netAmount: 1400,
// 		taxTotal: 100,
// 		isAwaitingTransfer: true,
// 		installments: 3,
// 		machineId: "1234",
// 		machineSerial: "ABC1234",
// 		transactionId: "T-0001",
// 		created_at: "2024-12-13T14:30:00Z",
// 		updated_at: "2024-12-13T14:30:00Z",
// 		status: 1,
// 	},
// 	{
// 		id: "2",
// 		type: "2",
// 		grossAmount: 500,
// 		netAmount: 480,
// 		taxTotal: 20,
// 		isAwaitingTransfer: false,
// 		installments: 1,
// 		machineId: "5678",
// 		machineSerial: "XYZ5678",
// 		transactionId: "T-0002",
// 		created_at: "2024-12-13T15:00:00Z",
// 		updated_at: "2024-12-13T15:00:00Z",
// 		status: 3,
// 	},
// 	{
// 		id: "3",
// 		type: "1",
// 		grossAmount: 2000,
// 		netAmount: 1900,
// 		taxTotal: 100,
// 		isAwaitingTransfer: false,
// 		installments: 2,
// 		machineId: "91011",
// 		machineSerial: "DEF91011",
// 		transactionId: "T-0003",
// 		created_at: "2024-12-13T16:00:00Z",
// 		updated_at: "2024-12-13T16:00:00Z",
// 		status: 4,
// 	},
// 	{
// 		id: "4",
// 		type: "1",
// 		grossAmount: 2000,
// 		netAmount: 1900,
// 		taxTotal: 100,
// 		isAwaitingTransfer: false,
// 		installments: 4,
// 		machineId: "91051",
// 		machineSerial: "DEF91011",
// 		transactionId: "T-0003",
// 		created_at: "2024-12-13T16:00:00Z",
// 		updated_at: "2024-12-13T16:00:00Z",
// 		status: 4,
// 	},
// 	{
// 		id: "5",
// 		type: "1",
// 		grossAmount: 2000,
// 		netAmount: 1900,
// 		taxTotal: 100,
// 		isAwaitingTransfer: false,
// 		installments: 2,
// 		machineId: "91011",
// 		machineSerial: "DEF91011",
// 		transactionId: "T-0003",
// 		created_at: "2024-12-13T17:00:00Z",
// 		updated_at: "2024-12-13T17:00:00Z",
// 		status: 3,
// 	},
// 	{
// 		id: "6",
// 		type: "1",
// 		grossAmount: 2000,
// 		netAmount: 1900,
// 		taxTotal: 100,
// 		isAwaitingTransfer: false,
// 		installments: 2,
// 		machineId: "91011",
// 		machineSerial: "DEF91011",
// 		transactionId: "T-0003",
// 		created_at: "2024-12-13T16:00:00Z",
// 		updated_at: "2024-12-13T16:00:00Z",
// 		status: 1,
// 	},
// 	{
// 		id: "7",
// 		type: "1",
// 		grossAmount: 2000,
// 		netAmount: 1900,
// 		taxTotal: 100,
// 		isAwaitingTransfer: false,
// 		installments: 2,
// 		machineId: "91011",
// 		machineSerial: "DEF91011",
// 		transactionId: "T-0003",
// 		created_at: "2024-12-13T16:00:00Z",
// 		updated_at: "2024-12-13T16:00:00Z",
// 		status: 1,
// 	},
// 	{
// 		id: "8",
// 		type: "1",
// 		grossAmount: 2000,
// 		netAmount: 1900,
// 		taxTotal: 100,
// 		isAwaitingTransfer: false,
// 		installments: 2,
// 		machineId: "91011",
// 		machineSerial: "DEF91011",
// 		transactionId: "T-0003",
// 		created_at: "2024-12-13T16:00:00Z",
// 		updated_at: "2024-12-13T16:00:00Z",
// 		status: 1,
// 	},
// 	{
// 		id: "9",
// 		type: "1",
// 		grossAmount: 2000,
// 		netAmount: 1900,
// 		taxTotal: 100,
// 		isAwaitingTransfer: false,
// 		installments: 2,
// 		machineId: "91011",
// 		machineSerial: "DEF91011",
// 		transactionId: "T-0003",
// 		created_at: "2024-12-13T16:00:00Z",
// 		updated_at: "2024-12-13T16:00:00Z",
// 		status: 1,
// 	},
// 	{
// 		id: "10",
// 		type: "1",
// 		grossAmount: 2000,
// 		netAmount: 1900,
// 		taxTotal: 100,
// 		isAwaitingTransfer: false,
// 		installments: 2,
// 		machineId: "91011",
// 		machineSerial: "DEF91011",
// 		transactionId: "T-0003",
// 		created_at: "2024-12-13T16:00:00Z",
// 		updated_at: "2024-12-13T16:00:00Z",
// 		status: 1,
// 	},
// 	{
// 		id: "11",
// 		type: "1",
// 		grossAmount: 2000,
// 		netAmount: 1900,
// 		taxTotal: 100,
// 		isAwaitingTransfer: false,
// 		installments: 2,
// 		machineId: "91011",
// 		machineSerial: "DEF91011",
// 		transactionId: "T-0003",
// 		created_at: "2024-12-13T16:00:00Z",
// 		updated_at: "2024-12-13T16:00:00Z",
// 		status: 1,
// 	},
// 	{
// 		id: "12",
// 		type: "1",
// 		grossAmount: 2000,
// 		netAmount: 1900,
// 		taxTotal: 100,
// 		isAwaitingTransfer: false,
// 		installments: 2,
// 		machineId: "91011",
// 		machineSerial: "DEF91011",
// 		transactionId: "T-0003",
// 		created_at: "2024-12-13T16:00:00Z",
// 		updated_at: "2024-12-13T16:00:00Z",
// 		status: 1,
// 	},
// ];

export function ReceiptPos() {
	const token = localStorage.getItem("@stricv2:token");

	const navigate = useNavigate();
	const [startDate, setStartDate] = useState(
		dayjs().subtract(1, "day").locale("pt-br"),
	);
	const [endDate, setEndDate] = useState(dayjs().locale("pt-br"));
	const [data, setData] = useState<TransactionDataPos[]>([]);
	const [selectedTransaction, setSelectedTransaction] =
		useState<TransactionDataPos>();
	const [detailsModalIsVisible, setDetailsModalIsVisible] =
		useState<boolean>(false);

	const { user } = useAuth();

	const handleRowClick = (transaction: TransactionDataPos) => {
		navigate(`/backoffice/transactions-pagbank/${transaction.id}`, {
			state: { transactionData: transaction },
		});
	};

	const fetchPlans = async () => {
		try {
			console.log(token);

			let url = `/pagbank/${startDate}/${endDate}/${user.id}`;
			const { data: responseData } = await api.get(url, {
				headers: { Authorization: "Bearer " + token },
			});

			if (responseData) {
				setData(responseData);
			} else {
				console.error("Não foram encontrados detalhes na resposta da API");
			}
		} catch (error) {
			console.error("Erro ao buscar os dados:", error);
		}
	};

	useEffect(() => {
		fetchPlans();
	}, [startDate, endDate]);

	const handleStartDateChange = (newDate: dayjs.Dayjs | null) => {
		if (newDate) setStartDate(newDate);
	};

	const handleEndDateChange = (newDate: dayjs.Dayjs | null) => {
		if (newDate) setEndDate(newDate);
	};

	const totalBruto = useMemo(() => {
		return data.reduce(
			(acc, transaction) =>
				(transaction.status == PagBankPaymentStatus["COMPLETE"] ||
					transaction.status == PagBankPaymentStatus["DONE"]) &&
				transaction.isAwaitingTransfer
					? acc + transaction.grossAmount
					: acc,
			0,
		);
	}, [data]);

	const totalLiquido = useMemo(() => {
		return data.reduce(
			(acc, transaction) =>
				(transaction.status == PagBankPaymentStatus["COMPLETE"] ||
					transaction.status == PagBankPaymentStatus["DONE"]) &&
				transaction.isAwaitingTransfer
					? acc + transaction.netAmount
					: acc,
			0,
		);
	}, [data]);

	return (
		<Container className="w-full">
			<Modal
				open={detailsModalIsVisible}
				onClickClose={() => setDetailsModalIsVisible(false)}
			>
				{selectedTransaction && (
					<TransactionPagbankDetail transaction={selectedTransaction} />
				)}
			</Modal>
			<Content className="w-full h-full padding-container items-center justify-center">
				<div className="flex flex-col items-center justify-center w-full px-[2%]">
					<span className="title-text">Relatório de vendas</span>
					<div className="w-full">
						<div className="w-full">
							<h3 className="date-text">Período</h3>
							<span className="p-text">Selecione um período</span>
						</div>
						<div className="flex w-full justify-between items-center mb-8">
							<div className="w-full">
								<div className="flex gap-4 w-full items-center mt-1">
									<div className="w-full flex flex-row h-full items-center gap-4">
										<DatePicker
											slotProps={{
												textField: {
													InputProps: {
														style: {
															fontSize: "1.5vw",
															width: "14vw",
															height: "6vh",
														},
													},
													InputLabelProps: {
														style: { fontSize: "1vw" },
													},
												},
											}}
											label="Data Inicial"
											value={startDate}
											onChange={handleStartDateChange}
											format="DD/MM/YYYY"
										/>
										<span className="p-text">até</span>
										<DatePicker
											slotProps={{
												textField: {
													InputProps: {
														style: {
															fontSize: "1.5vw",
															width: "14vw",
															height: "6vh",
														},
													},
													InputLabelProps: {
														style: { fontSize: "1vw" },
													},
												},
											}}
											label="Data Final"
											value={endDate}
											onChange={handleEndDateChange}
											format="DD/MM/YYYY"
										/>
									</div>
								</div>
							</div>
							<div>
								{/* <button
									type="button"
									className="items-center bg-white p-2 rounded shadow border border-blue-500"
								>
									<span className="flex items-center font-medium p-text text-blue-500 whitespace-nowrap">
										<Upload
											color="#5393F3"
											className="mt-[2px] export-icon duration-100"
										/>
										<span className="margin-icon-text">Exportar relatório</span>
									</span>
								</button> */}
							</div>
						</div>
						<div className="overflow-x-auto w-full">
							<div className="table-container">
								<table className="w-full border-collapse table-fixed">
									<thead>
										<tr className="text-center font-semibold bg-white">
											<th
												style={{ color: "#686868" }}
												className="table-title w-1/6"
											>
												Data e hora
											</th>
											<th
												style={{ color: "#686868" }}
												className="table-title w-1/6"
											>
												Forma de pagamento
											</th>
											<th
												style={{ color: "#686868" }}
												className="table-title w-1/6"
											>
												Canal de venda
											</th>
											<th
												style={{ color: "#686868" }}
												className="table-title w-1/6"
											>
												Status
											</th>
											<th
												style={{ color: "#686868" }}
												className="table-title w-1/6"
											>
												Valor bruto
											</th>
											<th
												style={{ color: "#686868" }}
												className="table-title w-1/6"
											>
												Valor líquido
											</th>
										</tr>
									</thead>
								</table>
								<table>
									<tbody className="w-full border-collapse overflow-y-auto height-table">
										{data.length === 0 ? (
											<tr>
												<td
													colSpan={6}
													style={{ color: "#686868" }}
													className="text-center py-4"
												>
													Não há dados para o período selecionado
												</td>
											</tr>
										) : (
											data.map((transaction, index) => (
												<tr
													key={index}
													onClick={() => {
														setSelectedTransaction(transaction);
														setDetailsModalIsVisible(true);
													}}
													className="text-center cursor-pointer font-semibold h-20 duration-150 hover:bg-gray-100"
												>
													<td
														className="table-text"
														style={{ color: "#686868" }}
													>
														{moment(transaction.created_at).format(
															"DD/MM/YYYY HH:mm",
														)}
													</td>
													<td
														className="table-text"
														style={{ color: "#686868" }}
													>
														Maquininha: {transaction.machineSerial}
													</td>
													<td className="table-text">
														{transaction.status ===
															PagBankPaymentStatus["COMPLETE"] ||
														transaction.status ===
															PagBankPaymentStatus["DONE"] ? (
															<div className="flex items-center justify-center">
																<CheckCircle2
																	color="#4AD858"
																	className="status-icon"
																/>
																<span>
																	Aprovada -{" "}
																	{transaction.isAwaitingTransfer
																		? "Aguardando repasse"
																		: "Pago"}
																</span>
															</div>
														) : transaction.status ===
															PagBankPaymentStatus["ANALYSIS"] ? (
															<div className="flex items-center justify-center">
																<Clock
																	color="#d3d84a"
																	className="status-icon"
																/>
																<span>Em análise</span>
															</div>
														) : transaction.status ===
															PagBankPaymentStatus["REFOUND"] ? (
															<div className="flex items-center justify-center">
																<Undo2
																	color="#d87c4a"
																	className="status-icon"
																/>
																<span>Devolvida</span>
															</div>
														) : (
															<div className="flex items-center justify-center">
																<XCircle
																	color="#d84a4a"
																	className="status-icon"
																/>
																<span>Cancelada</span>
															</div>
														)}
													</td>
													<td
														className="table-text"
														style={{ color: "#588DA5" }}
													>
														{transaction.type === "1"
															? `Crédito ${transaction.installments}x`
															: `Débito`}
													</td>
													<td
														className="table-text"
														style={{ color: "#686868" }}
													>
														R$ {toLocaleAmount(transaction.grossAmount)}
													</td>
													<td
														className="table-text"
														style={{ color: "#686868" }}
													>
														R${" "}
														{toLocaleAmount(
															transaction.status !==
																PagBankPaymentStatus["COMPLETE"] &&
																transaction.status !==
																	PagBankPaymentStatus["DONE"]
																? 0
																: transaction.netAmount,
														)}
													</td>
												</tr>
											))
										)}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</Content>
		</Container>
	);
}
